module.exports = __webpack_public_path__ + "static/img/gtxj.8dd64ac9.png";